import type { IconNode } from '../types';

/**
 * @name baseline-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik05LjUgMTJoNSIgLz4KICA8cGF0aCBkPSJtOSAxMyAzLTYgMyA2IiAvPgogIDxwYXRoIGQ9Ik03IDE3aDEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/baseline-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const baselineSquare: IconNode = [
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' }],
  ['path', { d: 'M9.5 12h5', key: 'p3hvm3' }],
  ['path', { d: 'm9 13 3-6 3 6', key: 'awtbkx' }],
  ['path', { d: 'M7 17h10', key: 'ecwlin' }],
];

export default baselineSquare;
